(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dog-size-selector"] && !Shopify.designMode) return;
  try {
    class SizeSelector extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.productType = this.dataset.productType;
    this.subscriptionId = this.dataset.subscriptionId;
    this.productData = null;
    this.initializeProductData();
  }

  initializeProductData() {
    // Resolve to a consistent shape: { data: <product> } with product.variants.
    // Two historical bugs lived here: (1) the Replo branch compared a numeric id to
    // a string productId (always false), and (2) it stored the product WITHOUT the
    // { data: ... } wrapper the rest of the class expects — so this.productData.data
    // was undefined and size selection silently bailed. Both are fixed below.
    try {
      const reploEl = document.getElementById('replo-deps-products');
      if (reploEl) {
        const products = JSON.parse(reploEl.textContent);
        const match = Array.isArray(products)
          ? products.find((p) => String(p.id) === String(this.productId))
          : null;
        if (match && Array.isArray(match.variants)) {
          this.productData = { data: match };
          return;
        }
      }
    } catch (e) {
      console.error('SizeSelector: error parsing Replo product data', e);
    }
    try {
      const jsonEl = document.getElementById(`ProductJson-${this.productId}`);
      if (jsonEl) {
        this.productData = { data: JSON.parse(jsonEl.textContent) };
      }
    } catch (e) {
      console.error('SizeSelector: error parsing ProductJson', e);
    }
  }

  connectedCallback() {
    this.addEventListener('change', this.handleSizeSelection.bind(this));
    this.hideSizeVariantPicker();

    // Keep the theme form's variant id in sync with BCPO's option swatches.
    // The live storefront's picker is rendered by BCPO (name0 = Size, name1 =
    // Colour, ...). BCPO updates its own swatches but does NOT reliably push the
    // selection into the <select name="id"> the cart submits — so a colour change
    // after a size change was lost. Whenever ANY BCPO option radio changes (whether
    // a customer taps a colour, or this component selects a size), recompute the
    // variant from BCPO's currently-checked radios and write it to the form.
    if (this.productType === 'bed') {
      document.addEventListener('change', (e) => {
        if (e && e.target && /^name\d+$/.test(e.target.name || '')) this.syncFromBcpo();
      }, true);
    }
  }

  syncFromBcpo() {
    let variants = (this.productData && this.productData.data && this.productData.data.variants) || null;
    if (!variants) {
      try {
        const jsonEl = document.getElementById(`ProductJson-${this.productId}`);
        if (jsonEl) variants = JSON.parse(jsonEl.textContent).variants;
      } catch (e) {}
    }
    if (!variants || !variants.length) return;

    // Read BCPO's currently-selected option values (name0 = Size, name1 = Colour,
    // ...). BCPO's own controls are the source of truth so customers can freely
    // change size AND colour; the dog-size weight selector only sets/recommends a
    // size by driving BCPO's size radio (see selectTargetRadio) — it does NOT
    // constrain the selection here.
    const opts = [];
    document.querySelectorAll('input[type="radio"][name^="name"]:checked').forEach((r) => {
      const m = /^name(\d+)$/.exec(r.name);
      if (m) opts[parseInt(m[1], 10)] = r.value;
    });

    // Persist the chosen Size across BCPO's sold-out "clear". When a sold-out combo
    // is selected, BCPO clears its size radio (name0), which would otherwise drop the
    // variant to the first size (Small) on the next colour change — e.g. choosing
    // Large/Beige (sold out) then Checkered would add Small/Checkered. So we remember
    // the last Size the customer actually selected (via BCPO's size swatch OR the
    // dog-size selector) and restore it whenever BCPO has cleared the size. An
    // explicit size change still updates this, so it never locks the picker.
    if (opts[0]) {
      this._intendedSize = opts[0];
    } else if (this._intendedSize) {
      opts[0] = this._intendedSize;
    }

    if (!opts.length) return;
    const variant = variants.find((v) => v.options.every((o, i) => opts[i] == null || o === opts[i]));
    if (variant) this.applyVariantToForm(variant);
  }

  hideSizeVariantPicker() {
    // Hide Symmetry's Size option selector since the dog size selector handles it
    if (this.productType !== 'bed') return;
    var hideSize = function() {
      var sizeSelector = document.querySelector('.option-selector[data-option-index="0"]');
      if (sizeSelector) sizeSelector.style.display = 'none';
      // NOTE: BCPO's own Size swatch is intentionally left visible — customers can
      // change the size directly with it; the dog-size weight selector only sets a
      // recommended size and must not constrain the picker.
    };
    hideSize();
    // Re-apply after BCPO async init
    setTimeout(hideSize, 500);
    setTimeout(hideSize, 1500);
    setTimeout(hideSize, 3000);
  }

  handleSizeSelection(event) {
    const targetValue = event.target.getAttribute('data-value-target');
    if (!targetValue) return;
    if (this.productType === 'bed') {
      this.selectTargetRadio(targetValue);
    } else if (this.productType === 'chews') {
      this.selectTargetOption(targetValue);
      this.updatePriceAndSavings(targetValue);
    }
  }

  selectTargetRadio(targetValue) {
    // Remember the size the customer chose via the dog-size selector, so it survives
    // BCPO clearing its size radio on sold-out combos (see syncFromBcpo).
    this._intendedSize = targetValue;

    // (Landing pages only) mark the matching size radio as recommended, if present.
    // On the standard Symmetry PDP there is no such <input value="Size">, so this is
    // skipped — it must NOT abort the rest of the method (the original early-return
    // here is what silently broke size selection on the PDP).
    const targetInput = document.querySelector(`input[value="${targetValue}"]`);
    if (targetInput) {
      targetInput.checked = true;
      targetInput.dispatchEvent(new Event('change', { bubbles: true }));
      targetInput.setAttribute('data-recommended', 'true');
      document.querySelectorAll(`input[name="${targetInput.name}"]:not([value="${targetValue}"])`).forEach((el) => {
        el.removeAttribute('data-recommended');
      });
    }

    // Resolve variants robustly — never depend solely on this.productData being
    // well-formed (Replo data races / shape differences). Fall back to the theme's
    // ProductJson, which is always present on the PDP.
    let variants = (this.productData && this.productData.data && this.productData.data.variants) || null;
    if (!variants) {
      try {
        const jsonEl = document.getElementById(`ProductJson-${this.productId}`);
        if (jsonEl) variants = JSON.parse(jsonEl.textContent).variants;
      } catch (e) {}
    }
    if (!variants || !variants.length) return;

    // ----- Landing-page picker (.sa-lphp__ option groups) -----
    const lpInputs = document.querySelectorAll('.sa-lphp__option-group input[data-option-index]');
    if (lpInputs.length > 0) {
      const targetVariant = variants.find((v) => v.option1 === targetValue && v.available)
                         || variants.find((v) => v.option1 === targetValue);
      if (!targetVariant) return;
      lpInputs.forEach((radio) => {
        const idx = parseInt(radio.getAttribute('data-option-index'), 10);
        if (!isNaN(idx) && targetVariant.options[idx] === radio.value && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      return;
    }

    // ----- Resolve the target variant (PICKER-AGNOSTIC) -----
    // Read the CURRENT colour from the currently-selected variant (the form's
    // [name="id"]), NOT from a specific picker's DOM. The live storefront renders
    // the picker with the BCPO options app (no Symmetry .option-selectors exist),
    // so we must not depend on theme selectors. Keep the colour if it's in stock in
    // the chosen size; else auto-switch to the first in-stock colour for that size.
    let currentColor = null;
    try {
      const idEl = document.querySelector('.product-purchase-form [name="id"]') || document.querySelector('[name="id"]');
      const cur = idEl && variants.find((v) => String(v.id) === String(idEl.value));
      if (cur) currentColor = cur.option2;
    } catch (e) {}

    let variant = variants.find((v) => v.option1 === targetValue && (currentColor == null || v.option2 === currentColor));
    if (!variant || !variant.available) {
      const firstAvailForSize = variants.find((v) => v.option1 === targetValue && v.available);
      if (firstAvailForSize) variant = firstAvailForSize;
      else if (!variant) variant = variants.find((v) => v.option1 === targetValue);
    }
    if (!variant) return;

    this.applyVariant(variant);
  }

  // Apply the chosen variant through EVERY selection mechanism that might be present,
  // so size selection works regardless of who renders the picker (Symmetry theme OR
  // the BCPO options app on the live storefront).
  applyVariant(variant) {
    if (!variant || variant.id == null) return;

    // 1) Symmetry theme dropdowns (.cc-select), if present — updates the visual picker.
    document.querySelectorAll('.option-selectors .option-selector').forEach((sel) => {
      const idx = parseInt(sel.getAttribute('data-option-index'), 10);
      const value = variant['option' + (idx + 1)];
      const cc = sel.querySelector('.cc-select');
      if (cc && value) cc.dispatchEvent(new CustomEvent('selectOption', { detail: { value: value } }));
    });

    // 2) BCPO options app radios, if present. BCPO names its option groups name0,
    //    name1, ... (one per product option). Activate the radio whose value matches
    //    each chosen option value, clicking its swatch so BCPO's own handler runs and
    //    updates the variant.
    variant.options.forEach((value, idx) => {
      let radios = Array.prototype.slice.call(document.querySelectorAll('input[type="radio"][name="name' + idx + '"]'));
      if (!radios.length) {
        radios = Array.prototype.slice.call(document.querySelectorAll('[class*="bcpo"] input[type="radio"], [id*="bcpo"] input[type="radio"]'));
      }
      const match = radios.find((r) => r.value === value);
      if (match && !match.checked) {
        match.checked = true;
        const lbl = match.id ? document.querySelector('label[for="' + match.id + '"]') : (match.closest && match.closest('label'));
        try { (lbl || match).click(); } catch (e) {}
        match.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // 3) Reliable baseline: set the form's variant id directly + fire the theme's
    //    native change so cart/price/URL/sticky follow even if neither picker reacts.
    this.applyVariantToForm(variant);
  }

  // Directly set every product-form variant id field to the given variant and emit
  // the same native, bubbling 'change' (with detail.variant) that the theme's own
  // variant logic emits, so all downstream listeners (price, URL, sticky bar) follow.
  applyVariantToForm(variant) {
    if (!variant || variant.id == null) return;
    const fields = document.querySelectorAll('.product-form [name="id"], form.product-purchase-form [name="id"], [name="id"]');
    fields.forEach((f) => {
      try { if (String(f.value) !== String(variant.id)) f.value = String(variant.id); } catch (e) {}
      f.dispatchEvent(new CustomEvent('change', { bubbles: true, cancelable: false, detail: { variant: variant } }));
    });
  }

  selectTargetOption(targetValue) {
    if (!this.subscriptionId) return;

    // Handle changing selling plan value
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    if (!sellingPlanInput) return;
    sellingPlanInput.value = targetValue;

    // Handle changing dropdown value and update options text
    const subscriptionDropdown = document.querySelector(`#loop-widget-sp-selector-dropdown-${this.subscriptionId}`);
    if (!subscriptionDropdown) return;

    // First, remove "(recommended)" from all options
    Array.from(subscriptionDropdown.options).forEach(option => {
      option.text = option.text.replace(' (recommended)', '');
    });

    // Update selected value and add "(recommended)" to the selected option
    subscriptionDropdown.value = targetValue;
    const selectedOption = subscriptionDropdown.options[subscriptionDropdown.selectedIndex];
    if (selectedOption) {
      selectedOption.text = `${selectedOption.text} (recommended)`;
    }

    // Handle changing Loop UI elements
    const oneTimePurchaseRadio = document.querySelector('[data-loop-widget-onetime-purchase-option]');
    const subscriptionRadio = document.querySelector(`#loop-widget-purchase-option-id-${this.subscriptionId}`);
    if (!subscriptionRadio || !oneTimePurchaseRadio) return;

    subscriptionRadio.setAttribute('data-recommended', 'true');
    const subscriptionSelected = subscriptionRadio.getAttribute('aria-checked') === 'true';
    if (!subscriptionSelected) {
      oneTimePurchaseRadio.setAttribute('aria-checked', 'false');
      oneTimePurchaseRadio.classList.remove('loop-widget-purchase-option-selected');
      oneTimePurchaseRadio.tabIndex = "-1";
      subscriptionRadio.setAttribute('aria-checked', 'true');
      subscriptionRadio.classList.add('loop-widget-purchase-option-selected');
      subscriptionRadio.tabIndex = "0";
      document.querySelector(`#loop-widget-spg-container-id-${this.subscriptionId}`)?.classList.add('expanded');
    }
  }

  updatePriceAndSavings(sellingPlanId) {
    if (!this.productData) return;

    const variant = this.productData.data.variants[0];
    const sellingPlan = variant.selling_plan_allocations.find(
      allocation => allocation.selling_plan_id.toString() === sellingPlanId
    );

    if (!sellingPlan) return;

    const regularPrice = variant.price;
    const subscriptionPrice = sellingPlan.price;
    const savings = regularPrice - subscriptionPrice;
    const savingsPercentage = Math.round((savings / regularPrice) * 100);

    // Update price display
    const priceElement = document.querySelector(`#loop-widget-purchase-option-price-id-${this.subscriptionId}`);
    if (priceElement) {
      priceElement.textContent = this.formatPrice(subscriptionPrice);
    }

    // Update savings badge
    const savingsBadge = document.querySelector(`#loop-widget-purchase-option-discount-badge-id-${this.subscriptionId}`);
    if (savingsBadge) {
      savingsBadge.textContent = `Save ${savingsPercentage}%`;
    }
  }

  formatPrice(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }
}

customElements.define('size-selector', SizeSelector);
  } catch(e) { console.error(e); }
})();

})();
